import { StateObject } from '~src/domains/common/types/common';

const docOrderSelector = (state: StateObject) => state.loanConsent.docOrder;

export { docOrderSelector };
